<template>
	<div class="message-list--item-appointment-info">
		<div class="message-list--item-appointment-info-dates">
			<span
				v-for="potentialDate in data.potentialDates"
				:key="potentialDate.id"
				class="message-list--item-appointment-info-date"
			>
				{{ formatDate(potentialDate) }}
			</span>
		</div>
		<div v-if="reasons" class="message-list--item-appointment-info-reasons">{{ reasons }}</div>
	</div>
</template>

<script>
import {DateTime} from "luxon";
import {getLabel} from "@/helper/communication/conversation/appointment/Reason";

export default {
	props: {
		data: {
			type: Object,
			required: true,
		}
	},

	computed: {
		reasons ()
		{
			if (!this.data.reasons)
			{
				return undefined;
			}

			return this.data.reasons
				.map(reason => getLabel(reason))
				.join(', ');
		}
	},

	methods: {
		formatDate (potentialDate)
		{
			return DateTime.fromObject({
				year: potentialDate.date.year,
				month: potentialDate.date.month,
				day: potentialDate.date.day,
				hour: potentialDate.time.hour,
				minute: potentialDate.time.minute
			}).toFormat('dd.LL.y HH:mm');
		}
	}
}
</script>
